var EVENT_KEY = ".ef.nav";
export var selectors = {
  NAVTOGGLE: ".ef-nav__toggle",
  NAV: ".ef-nav",
  TOGGLEICON: ".ef-header__icon.-animated",
  NAVITEM: ".ef-nav__link",
  SUBNAVGROUP: ".-with-sub-menu",
  SUBNAVTOGGLE: ".ef-nav__sub-menu-toggle",
  SUBNAV: ".ef-nav__sub-menu",
  HEADER: ".ef-header"
};
export var classNames = {
  BODYHASOPENNAV: "-no-scroll",
  HEADEROPEN: "-ef-nav--is-open",
  NAVACTIVE: "-active"
};
export var events = {
  SHOWN: "".concat(EVENT_KEY, ".shown"),
  HIDDEN: "".concat(EVENT_KEY, ".hidden")
};